module.exports = __webpack_public_path__ + "img/white-logo-golden-pharma.7ab190c2.png";